// extracted by mini-css-extract-plugin
module.exports = {"homeFloat":"index-module_homeFloat_3hs5q"};